import React from 'react';

export type DeviceContextType = {
  platform: string | null;
  gpb_supported: boolean;
};

const DeviceContext = React.createContext<DeviceContextType>({
  platform: null,
  gpb_supported: false,
});

export default DeviceContext;
